import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from '@/legacy/hooks/useToast';
import type { ProfileInfoForm } from '../domain/schemas';

export const useProfileSaveFeedback = () => {
	const { t, i18n } = useTranslation();
	const { showToast } = useToast();

	const onUpdated = useCallback(
		(form: ProfileInfoForm) => {
			i18n.changeLanguage(form.locale);
			showToast(t('success.update_success'), 'success');
		},
		[i18n, showToast, t],
	);

	const onFailed = useCallback(() => showToast(t('errors.update_error'), 'error'), [showToast, t]);

	return { onUpdated, onFailed };
};
